import { PROTOCOL_TO_NAME } from "@/constants/mod-perms-tool.constants";

export default function resolveProtocol(protocol: string | undefined): string {
  if (!protocol) return "-";
  const chainName = PROTOCOL_TO_NAME[protocol];
  return chainName || protocol;
}
